import React from 'react';
import { createStyles } from './theme-context';
import { OrderInboundsDetailTabs } from '@/screens/order-inbounds/order-inbounds-detail-tabs/order-inbounds-detail-tabs';
import { OrderMetadata } from '@/screens/order-inbounds/types';

export interface Props {
  isSummaryView?: boolean;
  orderMetadata: OrderMetadata[];
}

export const OriginalInboundContent: React.FC<Props> = ({
  isSummaryView,
  orderMetadata,
}) => {
  const [styles] = useStyles();

  return (
    <OrderInboundsDetailTabs
      containerStyle={styles.containerStyle}
      isSummaryView={isSummaryView}
      orderMetadata={orderMetadata}
    />
  );
};

const useStyles = createStyles((theme) => ({
  containerStyle: {
    backgroundColor: theme.colors.transparent,
  },
}));
